export enum UserRole {
  None = 0,
  User,
  BuAdmin,
  OrgAdmin,
  SysAdmin,
}
